<template>
  <TextBase is="p" :color="props.color" :size="props.size" :font="props.font">
    <slot />
  </TextBase>
</template>

<script setup>
import TextBase from './TextBase.vue'

const props = defineProps({
  color: {
    type: String,
    default: 'text-gray-600',
  },
  size: {
    type: String,
    default: 'text-sm',
  },
  font: {
    type: String,
    default: 'font-normal',
  },
})
</script>
